import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=5b3ec3da&scoped=true"
import script from "./NotificationForm.vue?vue&type=script&lang=js"
export * from "./NotificationForm.vue?vue&type=script&lang=js"
import style0 from "./NotificationForm.vue?vue&type=style&index=0&id=5b3ec3da&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ec3da",
  null
  
)

export default component.exports